import "../../../styles/uyelikler.css";
import { initUyeliklerFilters, resetUyeliklerFilters } from "./uyeliklerFilters.js";
import { initUyeliklerGridEvents } from "./uyeliklerGrid.js";
import { initUyeliklerCreateDialog } from "./dialogs/create/createDialog.js";
import { initUyeliklerDeleteDialog } from "./dialogs/deleteDialog.js";
import { initUyeliklerDurumDialog } from "./dialogs/durumDialog.js";
import { initUyeliklerOverviewDialog } from "./dialogs/overviewDialog.js";
import { initUyeliklerEditDialog } from "./dialogs/editDialog.js";
import { initUyeliklerSifreDialog } from "./dialogs/sifreDialog.js";

let initialized = false;

function ensureUyeliklerView() {
    if (document.getElementById("uyelikler-view")) return;
    document.getElementById("page-content").insertAdjacentHTML("beforeend", `
<div id="uyelikler-view">
    <div class="page-section" id="uyelikler-filter-section">
        <div class="section-header">
            <div class="section-header-left">
                <span class="material-icons section-icon">filter_list</span>
                <span class="section-title">Filtreler</span>
                <span class="filter-aktif-badge" hidden>
                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
                        <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"/>
                    </svg>
                    Filtre aktif
                </span>
            </div>
            <div class="section-header-right">
                <button class="uyelikler-collapse-btn section-collapse-btn" title="Daralt/Genişlet">
                    <span class="material-icons">expand_less</span>
                </button>
            </div>
        </div>
        <div class="section-body">
            <div class="kisiler-filter-row">
                <div class="column-container">
                    <label for="uyelikler-yetki-filter">Yetki</label>
                    <select id="uyelikler-yetki-filter"><option value="">Tümü</option></select>
                </div>
                <div class="column-container">
                    <label for="uyelikler-durum-filter">Üyelik Durumu</label>
                    <select id="uyelikler-durum-filter">
                        <option value="">Tümü</option>
                        <option value="aktif">Aktif</option>
                        <option value="pasif">Pasif</option>
                    </select>
                </div>
                <div class="column-container">
                    <label for="uyelikler-ad-filter">Ad</label>
                    <input type="text" id="uyelikler-ad-filter" placeholder="Ada göre ara..." maxlength="100" />
                </div>
                <div class="column-container">
                    <label for="uyelikler-soyad-filter">Soyad</label>
                    <input type="text" id="uyelikler-soyad-filter" placeholder="Soyada göre ara..." maxlength="100" />
                </div>
                <div class="column-container">
                    <label for="uyelikler-tc-filter">T.C. Kimlik No</label>
                    <input type="text" id="uyelikler-tc-filter" placeholder="TC ile ara..." maxlength="11" inputmode="numeric" />
                </div>
                <div class="filter-button-container">
                    <button class="uyelikler-filter-reset">Temizle</button>
                    <button class="uyelikler-search">Ara</button>
                </div>
            </div>
        </div>
    </div>
    <div class="page-section" id="uyelikler-table-section">
        <div class="section-header">
            <div class="section-header-left">
                <span class="section-title">Üyeler</span>
                <span class="section-count" id="uyelikler-count"></span>
            </div>
            <div class="section-header-right">
                <button class="uyelikler-ekle btn-header-action btn-header-action--primary">
                    <span class="material-icons">add</span>
                    Ekle
                </button>
            </div>
        </div>
        <div class="section-body">
            <div class="uyelikler-table-grid"></div>
        </div>
    </div>
</div>`);
}

export function renderUyeliklerPage() {
    ensureUyeliklerView();
    initUyeliklerFilters();
    initUyeliklerGridEvents();
    initUyeliklerCreateDialog();
    initUyeliklerDeleteDialog();
    initUyeliklerDurumDialog();
    initUyeliklerOverviewDialog();
    initUyeliklerEditDialog();
    initUyeliklerSifreDialog();

    if (!initialized) {
        initialized = true;
        initUyeliklerSectionCollapse();
    }
}

function initUyeliklerSectionCollapse() {
    document.querySelectorAll("#uyelikler-view .section-collapse-btn").forEach((btn) => {
        btn.addEventListener("click", () => {
            btn.closest(".page-section").classList.toggle("collapsed");
        });
    });
}

export function resetUyeliklerPage() {
    resetUyeliklerFilters();
}
